import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  FormControl,
  FormHelperText,
  Grid,
  Stack,
  TextField,
  Typography,
} from '@mui/material';
import { type Control, Controller } from 'react-hook-form';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import ElectricalServicesIcon from '@mui/icons-material/ElectricalServices';

import { type EditAuditFormBackgroundData } from '#apps/client-web/pages/audit-form-background/types';
import { getFormErrorAttributes } from '#apps/client-web/app/helpers/react-hook-form';
import { BACKGROUND_FIELD_DESCRIPTIONS } from '#apps/client-web/features/audit-form-background/constants';
import { useFormDescriptions } from '#apps/client-web/features/settings/hooks/use-form-descriptions';

export type MainBreakerFieldsProps = {
  control: Control<EditAuditFormBackgroundData>;
  disableForm: boolean;
};

export const MainBreakerFields = ({
  control,
  disableForm,
}: MainBreakerFieldsProps) => {
  const getDescription = useFormDescriptions(BACKGROUND_FIELD_DESCRIPTIONS);

  return (
    <Accordion variant="outlined">
      <AccordionSummary
        expandIcon={<ExpandMoreIcon />}
        aria-controls="main-breaker-content"
        id="main-breaker-header">
        <Stack direction="row" alignItems="center" spacing={1}>
          <ElectricalServicesIcon fontSize="small" />
          <Typography variant="body1">Main Breaker</Typography>
        </Stack>
      </AccordionSummary>
      <AccordionDetails>
        <Stack spacing={3}>
          <Controller
            control={control}
            name="mainBreaker.location"
            disabled={disableForm}
            rules={{ maxLength: 250 }}
            render={({ field, fieldState }) => (
              <FormControl
                fullWidth
                {...getFormErrorAttributes(fieldState.error)}>
                <TextField
                  {...field}
                  label="Location"
                  type="text"
                  variant="outlined"
                  {...getFormErrorAttributes(fieldState.error)}
                />
                <FormHelperText>{fieldState.error?.message ?? getDescription(field.name)}</FormHelperText>
              </FormControl>
            )}
          />
          <Grid container spacing={2}>
            <Grid size={{ xs: 6 }}>
              <Controller
                control={control}
                name="mainBreaker.amperage"
                disabled={disableForm}
                render={({ field, fieldState }) => (
                  <FormControl
                    fullWidth
                    {...getFormErrorAttributes(fieldState.error)}>
                    <TextField
                      {...field}
                      label="Amperage (A)"
                      type="number"
                      variant="outlined"
                      {...getFormErrorAttributes(fieldState.error)}
                    />
                    <FormHelperText>{fieldState.error?.message ?? getDescription(field.name)}</FormHelperText>
                  </FormControl>
                )}
              />
            </Grid>
            <Grid size={{ xs: 6 }}>
              <Controller
                control={control}
                name="mainBreaker.voltage"
                disabled={disableForm}
                render={({ field, fieldState }) => (
                  <FormControl
                    fullWidth
                    {...getFormErrorAttributes(fieldState.error)}>
                    <TextField
                      {...field}
                      label="Voltage (V)"
                      type="number"
                      variant="outlined"
                      {...getFormErrorAttributes(fieldState.error)}
                    />
                    <FormHelperText>{fieldState.error?.message ?? getDescription(field.name)}</FormHelperText>
                  </FormControl>
                )}
              />
            </Grid>
          </Grid>
        </Stack>
      </AccordionDetails>
    </Accordion>
  );
};
